import { connectRouter, routerMiddleware } from 'connected-react-router'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'

import type { AppState} from '@app/state';
import { initialState, reducers } from '@app/state'
import { beginInitSaga } from '@app/state/init'

import type { History } from 'history'
import type { Store } from 'redux';

export function configureStore(history: History): Store<AppState> {
  const sagaMiddleware = createSagaMiddleware()
  const middlewares = [routerMiddleware(history), sagaMiddleware]
  const storeEnhancer = composeWithDevTools(applyMiddleware(...middlewares))
  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history),
  })

  const store = createStore(rootReducer, initialState, storeEnhancer)

  sagaMiddleware.run(beginInitSaga)

  return store
}
